import VueRouter, { isNavigationFailure, NavigationFailureType, RawLocation } from "vue-router";

// A guard declining (next(false)), a newer navigation superseding, or a push to the
// current location are outcomes, not errors. Most callers fire-and-forget push/replace,
// so rejecting with them leaked as unhandled rejections (VUE-146). push/replace resolve
// with the NavigationFailure instead — callers that must react check
// `isNavigationFailure(result, type)`. Anything else (guard redirect, guard error)
// still rejects.
const EXPECTED_FAILURE_TYPES = [
    NavigationFailureType.aborted,
    NavigationFailureType.cancelled,
    NavigationFailureType.duplicated
];

function resolveExpectedFailure(error: unknown) {
    if (EXPECTED_FAILURE_TYPES.some(type => isNavigationFailure(error, type))) {
        return error;
    }
    throw error;
}

export function resolveExpectedNavigationFailures(router: VueRouter) {
    const originalPush = router.push;
    router.push = function push(location: RawLocation) {
        return originalPush.call(this, location).catch(resolveExpectedFailure);
    };

    const originalReplace = router.replace;
    router.replace = function replace(location: RawLocation) {
        return originalReplace.call(this, location).catch(resolveExpectedFailure);
    };
}
